import { render, staticRenderFns } from "./GroupActivityBus.vue?vue&type=template&id=19a2ec91"
import script from "./GroupActivityBus.vue?vue&type=script&lang=js"
export * from "./GroupActivityBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports